export default "__VITE_ASSET__bKHyBsYb__"